import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  background-color: var(--color-blue);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 400px;

  div#logo-container {
    display: flex;
    justify-content: center;
    margin-bottom: var(--margin-xl);

    img {
      width: 100%;
      height: auto;
    }
  }

  h1 {
    text-align: center;
    text-transform: uppercase;
    color: var(--color-white);
    margin-bottom: var(--margin-xl);
  }

  form {
    width: inherit;
    background-color: var(--color-white);
    padding: var(--padding-xl);
    text-align: center; // center the button element

    h2 {
      text-transform: uppercase;
      text-align: center;
      margin-bottom: var(--margin-xl);
    }

    input {
      display: block;
      width: 100%;
      padding: var(--padding-sm);
      margin-bottom: var(--margin-sm);
      font-size: 1.6rem;
      // text-transform: uppercase;
    }

    input:nth-child(3) {
      margin-bottom: var(--margin-xl);
    }

    button {
      background-color: var(--color-purple);
      color: var(--color-white);
      padding: var(--padding-sm);
      font-size: 1.6rem;
      text-transform: uppercase;
      border: none;
    }

    button:hover {
      cursor: pointer;
    }
  }
`;
